export const DEFAULT_PLACEHOLDER = '--';

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const firstLetterUp = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);

export const isValidEmail = (email: string) => {
  let reg = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return Boolean(reg.test(email));
};

export const convertWebBoolean = (v: unknown) => String(v) == 'true';

export const removeEmailFromValue = (value?: string) => value?.replace(/\s<[\w.+-]+@[\w.-]+\.[a-zA-Z]{2,}>$/, '') ?? '';

export const extractNumberFromString = (str?: string) => str?.match(/\d+/)?.[0] ?? null;

export const extractLettersFromString = (str?: string) => str?.match(/[^\d]+/)?.[0] ?? null;

export const insertPathBreakOpportunities = (path: string) => path.replace(/\\/g, '\u200B\\');
